<template>
    <v-dialog v-model="dialog2" v-if="dialog2">
        <v-card width="1000px" class="py-2" style="border-radius: 12px;">
            <h1 class="text-center dialog-title"> {{ $t('suppliers.locationTab.add') }}</h1>
            <div v-if="loader" style="height: 250px; line-height: 250px;">
                <v-progress-circular indeterminate :size="50"></v-progress-circular>
            </div>
            <div v-else class="row ma-4">
                <div class="col-7 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('suppliers.locationTab.locationName') }}
                            <span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="locationName" variant="outlined" hide-details persistent-placeholder
                            name="locationName" id="locationName"></v-text-field>
                        <span class='warningHint' id="WarningMsgName">{{ msg.locationName }}</span>
                    </div>
                </div>

                <div class="col-5 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('suppliers.locationTab.contactNumber') }}
                            <span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="contactNumber" variant="outlined" hide-details persistent-placeholder
                            name="contactNumber" id="contactNumber"></v-text-field>
                        <span class='warningHint' id="WarningMsgName">{{ msg.contactNumber }}</span>
                    </div>
                </div>

                <div class="col-12 justify-content-start mt-2" style="line-height: 100%;">
                    <p><strong>Adresse :</strong> {{ address }}</p>
                    <p><strong>Ville :</strong> {{ city }}</p>
                    <p><strong>Pays :</strong> {{ country }}</p>
                    <p><strong>Code Postal :</strong> {{ postcode }}</p>
                </div>

                <div class="col-12 justify-content-centre align-centre mt-2">
                    <div class="row">
                        <l-map :zoom="13" :center="markerLatLng" style="height: 300px; width: 100%;"
                            @click="onMapClick">
                            <l-tile-layer :url="tileUrl" :attribution="tileAttribution" />
                            <l-marker :lat-lng="markerLatLng" :draggable="true" @update:lat-lng="onMarkerDrag" />
                        </l-map>
                    </div>
                </div>
            </div>

            <card-actions :yes="addSupplierLocation" v-model:no="dialog2" width="300px" :yesDisable="loaderGeoInfo"
                :yesTitle="$t('suppliers.locationTab.add')" />
        </v-card>
    </v-dialog>
</template>
<script>
import { addSupplierLocation, isSupplier, idSupplier } from "@/api/index";
import cardActions from "@/genericComponent/cardActions.vue"
import { LMap, LTileLayer, LMarker } from '@vue-leaflet/vue-leaflet'

export default {
    props: {
        reloadListLocation: {}
    },
    components: {
        cardActions, LMap, LTileLayer, LMarker
    },
    data() {
        return {
            msg: [],
            idSupplier: null,
            dialog2: true,
            locationName: null,
            contactNumber: null,
            address: null,
            postalCode: null,
            city: null,
            country: null,
            markerLatLng: [0, 0],
            tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            tileAttribution: '&copy; OpenStreetMap contributors',
            loaderGeoInfo: false,
            loader: false
        };
    },
    created() {
        this.idSupplier = isSupplier() ? idSupplier() : this.$route.params.id;
    },
    mounted() {
        this.getCurrentPosition()
    },
    watch: {
        dialog2(value) {
            this.dialog2 = value
            this.getCurrentPosition();
            this.$emit('add-location-close-dialog')
            this.dialog2 = true
            this.locationName = null
            this.contactNumber = null
            this.address = null
            this.postalCode = null
            this.city = null
            this.country = null
            this.msg = []
        },
    },
    methods: {
        addSupplierLocation() {
            if (!(this.locationName) || (this.locationName).length == 0) {
                this.msg['locationName'] = this.$t("warningInput.isrequired", { itm: this.$t("suppliers.locationTab.locationName") });
            }
            else {
                this.msg['locationName'] = '';
            }

            if (!(this.contactNumber) || (this.contactNumber).length == 0) {
                this.msg['contactNumber'] = this.$t("warningInput.isrequired", { itm: this.$t("suppliers.locationTab.contactNumber") });
            }
            else {
                this.msg['contactNumber'] = '';
            }

            if (
                this.msg["locationName"] == "" && 
                this.msg["contactNumber"] == ""
            ) {
                this.$emit('add-location-close-dialog');
                addSupplierLocation({
                    idSupplier: this.idSupplier,
                    locationName: this.locationName,
                    contactNumber: this.contactNumber,
                    address: this.address,
                    postalCode: this.postcode,
                    city: this.city,
                    country: this.country,
                    url: this.url
                })
                    .then(() => {
                        this.ActiveSavedSnackBar();
                        this.reloadListLocation();
                    }).catch(() => {
                        this.ActiveWarningSnackBar();
                    }).finally(() => {
                        setTimeout(() => {
                            this.locationName = null;
                            this.contactNumber = null;
                            this.address = null;
                            this.postalCode = null;
                            this.city = null;
                            this.country = null;
                            this.url = null;
                        }, 2000);
                    });

            }
        },
        ActiveDeletedSnackBar() {
            this.getParent('MainLayout').ActiveDeletedSnackBar();
        },
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        onMapClick(e) {
            this.markerLatLng = [e.latlng.lat, e.latlng.lng]
            this.url = this.generateGoogleMapsUrl(e.latlng.lat, e.latlng.lng)
            this.reverseGeocode(e.latlng.lat, e.latlng.lng)
        },
        onMarkerDrag(newLatLng) {
            this.markerLatLng = [newLatLng.lat, newLatLng.lng]
            this.url = this.generateGoogleMapsUrl(newLatLng.lat, newLatLng.lng)
        },
        generateGoogleMapsUrl(lat, lng) {
            return `https://www.google.com/maps/@${lat},${lng}`;
        },
        getCurrentPosition() {
            if (!navigator.geolocation) {
                alert("La géolocalisation n'est pas supportée par votre navigateur.")
                return
            }
            navigator.geolocation.getCurrentPosition(
                position => {
                    const { latitude, longitude } = position.coords
                    this.center = [latitude, longitude]
                    this.markerLatLng = [latitude, longitude]
                    this.zoom = 15

                    this.markerLatLng[0] = latitude
                    this.markerLatLng[1] = longitude
                    this.url = this.generateGoogleMapsUrl(latitude, longitude)
                    
                    this.reverseGeocode(this.markerLatLng[0], this.markerLatLng[1])

                    this.loader = false;
                },
            )
        },
        async reverseGeocode(lat, lon) {
            try {
                this.loaderGeoInfo = true;

                const response = await fetch(
                    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
                )
                const data = await response.json()
                const address = data.address

                this.city = address.city || address.town || address.village || address.state || '';
                this.country = address.country || '';
                this.postcode = address.postcode || '';
                this.address = data.display_name || ''
            } catch (err) {
                console.error('Erreur reverse geocoding :', err)
            } finally {
                this.loaderGeoInfo = false;
            }
            
        }
    },
};
</script>
<style scoped>
h1 {
    font-family: inter;
    font-size: 18px;
    line-height: 29px;
    font-weight: 600;
    color: #0d0849;
    text-align: center;
}

.v-dialog .v-card {
    border-radius: 12px;
    background-color: #fff;
}

.v-card-title {
    font-family: inter;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #0d0849;
    margin-left: 40px;
    margin-top: -30px;
}

.v-card-text {
    margin-left: 40px;
    font-family: inter;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    color: #768da9;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}
</style>